import * as React from "react"
import styled from "styled-components"

import Text from "../text"
import { Colors } from "../../theme"
import Overlay from "./see-more-box-overlay.component"

const ExpandCollapseText = styled(Text as any)`
  text-align: left;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
interface Props {
  collapsedHeight: number
  hideSeeMoreButton: boolean
}

interface State {
  isCollapsed: boolean
  contentAlreadyFitsBox: boolean
}

class SeeMoreBox extends React.PureComponent<Props, State> {
  content: any
  state = {
    isCollapsed: true,
    contentAlreadyFitsBox: false
  }

  componentDidMount() {
    this.content = React.createRef()
    if (this.content.clientHeight < this.props.collapsedHeight) {
      this.setState({ contentAlreadyFitsBox: true })
    }
  }

  toggleSection = () => this.setState(({ isCollapsed }) => ({ isCollapsed: !isCollapsed }))

  render() {
    const { collapsedHeight, hideSeeMoreButton } = this.props
    const { isCollapsed, contentAlreadyFitsBox } = this.state
    const boxHeight = contentAlreadyFitsBox || !isCollapsed ? "auto" : collapsedHeight
    return (
      <React.Fragment>
        <div
          style={{
            width: "100%",
            height: boxHeight,
            transitionDuration: "0.25s",
            overflow: "hidden",
            position: "relative"
          }}
          onClick={() => {
            if (hideSeeMoreButton && !contentAlreadyFitsBox) {
              this.toggleSection()
            }
          }}
        >
          {isCollapsed && hideSeeMoreButton && <Overlay />}
          <div ref={e => (this.content = e)}>{this.props.children}</div>
        </div>
        {!hideSeeMoreButton && !contentAlreadyFitsBox && (
          <ExpandCollapseText
            fontSize={18}
            fontWeight={600}
            color={Colors.primary}
            onClick={this.toggleSection}
          >
            {isCollapsed ? "See more" : "See less"}
          </ExpandCollapseText>
        )}
      </React.Fragment>
    )
  }
}

export default SeeMoreBox
